<template>

  <div class="flex items-center error-div" v-if="accountHasCampaigns">
    <span class="speakol icon-size speakol-calendar icon-span"></span>
    <span>
      There is no data showing for the date you have specified.
    </span>
  </div>

  <div class="flex items-center error-div" v-else>
    <span class="speakol icon-size speakol-no-horn icon-span"></span>
    <span>
      You do not have any campaigns.
    </span>
  </div>

</template>

<script>

export default {
  props: {
    accountHasCampaigns: {
      type: Boolean,
      default: true
    }
  }
}

</script>

<style lang="scss" scoped>
.error-div {
  background-color: white;
  color: #2c2c2c;
}

.icon-span {
  font-size: 25px;
  background-color: white;
  margin: 8px;
}
</style>
